import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api/request'
import {
  GETRevenueGroupAdministraionResponse,
  GETRevenueGroupResponse,
  IGetRevenueGroupsResponse,
  IRevenueGroup
} from '@cbgms/api/modules/revenuegroups'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { DELETEResponse, IUUIDResponse, PUTRevenueLedgerBody, PUTRevenueLedgerResponse } from '@cbgms/api'

export const loadRevenueGroups = (params: IPaginatedRequest = {}) =>
  AsyncAction<IGetRevenueGroupsResponse>({
    type: [types.LOAD_REVENUE_GROUPS, types.LOAD_REVENUE_GROUPS_SUCCESS, types.LOAD_REVENUE_GROUPS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/revenue-groups',
        params
      }
    }
  })

export const getRevenueGroup = (revenueGroupUUID: string) =>
  AsyncAction<GETRevenueGroupResponse>({
    type: [types.LOAD_REVENUE_GROUP, types.LOAD_REVENUE_GROUP_SUCCESS, types.LOAD_REVENUE_GROUP_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/accountancy/revenue-groups/${revenueGroupUUID}`
      }
    }
  })

export const createRevenueGroup = (data: Partial<IRevenueGroup>) =>
  AsyncAction<IUUIDResponse>({
    type: [types.CREATE_REVENUE_GROUP, types.CREATE_REVENUE_GROUP_SUCCESS, types.CREATE_REVENUE_GROUP_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/accountancy/revenue-groups',
        data
      }
    }
  })

export const updateRevenueGroup = (revenueGroupUUID: string, data: Partial<IRevenueGroup>) => ({
  type: [types.UPDATE_REVENUE_GROUP, types.UPDATE_REVENUE_GROUP_SUCCESS, types.UPDATE_REVENUE_GROUP_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/accountancy/revenue-groups/${revenueGroupUUID}`,
      data
    }
  }
})

export const deleteRevenueGroup = (revenueGroupUUID: string, DryRun: boolean) =>
  AsyncAction<DELETEResponse>({
    type: [types.DELETE_REVENUE_GROUP, types.DELETE_REVENUE_GROUP_SUCCESS, types.DELETE_REVENUE_GROUP_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/accountancy/revenue-groups/${revenueGroupUUID}`,
        params: {
          DryRun
        }
      }
    }
  })

export const getRevenueGroupAdministrationsLedgers = (revenueGroupUUID: string | undefined) =>
  AsyncAction<GETRevenueGroupAdministraionResponse>({
    type: [
      types.LOAD_REVENUE_LEDGERS_FOR_ADMINISTRATION,
      types.LOAD_REVENUE_LEDGERS_FOR_ADMINISTRATION_SUCCESS,
      types.LOAD_REVENUE_LEDGERS_FOR_ADMINISTRATION_FAILED
    ],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/accountancy/ledgers-for-revenueadministration/${revenueGroupUUID}`
      }
    }
  })

export const putRevenueGroupAdministrationsLedgers = (revenueGroupUUID: string | undefined, data: PUTRevenueLedgerBody) =>
  AsyncAction<PUTRevenueLedgerResponse>({
    type: [
      types.UPDATE_REVENUE_LEDGER_FOR_ADMINISTRATION,
      types.UPDATE_REVENUE_LEDGER_FOR_ADMINISTRATION_SUCCESS,
      types.UPDATE_REVENUE_LEDGER_FOR_ADMINISTRATION_FAILED
    ],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/accountancy/ledgers-for-revenueadministration/${revenueGroupUUID}`,
        data
      }
    }
  })
